import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventService {
    private abrirTermoSource = new Subject<any>();
    private abrirTermoUso = new Subject<any>();

    abrirTermoUso$ = this.abrirTermoUso.asObservable();
    abrirTermo$ = this.abrirTermoSource.asObservable();

    publishAbrirTermo(data?: any) {
        this.abrirTermoSource.next(data);
    }
    abrirTermoDeUso(data?: any){
        this.abrirTermoUso.next(data);
    }
}
